export var HubspotSyncTypes = /*#__PURE__*/ function(HubspotSyncTypes) {
    HubspotSyncTypes["SyncTwoWay"] = "SYNC_TWO_WAY";
    HubspotSyncTypes["SyncNativeToExternal"] = "SYNC_NATIVE_TO_EXTERNAL";
    HubspotSyncTypes["SyncExternalToNative"] = "SYNC_EXTERNAL_TO_NATIVE";
    HubspotSyncTypes["None"] = "NONE";
    return HubspotSyncTypes;
}({});
